import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './SampleParameter.module.css';

import type { VariantData } from '@Types/Product';
import type { FC, HTMLAttributes } from 'react';

export interface SampleParameterProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  material: VariantData;
}

const SampleParameter: FC<SampleParameterProps> = (props) => {
  const { className, material, ...restProps } = props;
  const { name, title, image, alt, description } = material;

  return (
    <div {...restProps} className={cn(styles.parameter, className)}>
      <span className={styles.name}>{`${name}:`}</span>
      <Img className={styles.imageWrapper} src={image} alt={alt} />
      <span className={styles.title}>{title}</span>
      {description && (
        <>
          {' '}
          <span className={styles.description}>{description}</span>
        </>
      )}
    </div>
  );
};

export default memo(SampleParameter);
